import { createApp } from 'vue';
import App from './App.vue';
import axiosPlugin from './plugins/axios';
import router from './router';
import store from './store';
import PortalVue from 'portal-vue';
import VueScrollTo from 'vue-scrollto';
import { plugin as VueInputAutowidth } from 'vue-input-autowidth';

// import style from '@speechki-frontend/shared/assets/scss/common.scss';

import i18n from '@speechki-frontend/core/i18n/i18n';

// @todo consider this, probably not the best way to share plugins
import tooltip from '@speechki-frontend/shared/helpers/plugins/tooltip';
import { NotifyPlugin } from '@speechki-frontend/shared/ui/Notify';

// global components @todo find a one place to share globals
import Spinner from '@speechki-frontend/shared/ui/Spinner';

// Sentry
import initSentry from '@speechki-frontend/shared/helpers/plugins/sentry';

const app = createApp(App);

app.component('Spinner', Spinner);

app.use(axiosPlugin);
app.use(i18n);
app.use(router);
app.use(store);
app.use(PortalVue);
app.use(VueScrollTo);
app.use(VueInputAutowidth);
app.use(tooltip);
app.use(NotifyPlugin);

app.config.globalProperties.$isManageApp = false;
app.config.globalProperties.$isClientApp = true;
app.config.globalProperties.$isCrmApp = false;

initSentry(app);

// vue-router 4 runs navigation guards asynchronously (unlike vue-router 3, where
// the first navigation resolved synchronously before the root instance was created).
// Mount only after the first navigation settles, so router.js's beforeEach guard has
// already written guest_token/refresh_token/comeback_url to sessionStorage before
// AuthProvider's created() hook reads them.
router
    .isReady()
    .catch((error) => {
        console.error('Initial navigation failed, mounting anyway', error);
    })
    .then(() => app.mount('#app'));
